const qualifications = values => (Array.isArray(values) ? values : values ? [values] : []).map(value => typeof value === "string" ? value : value?.name || value?.label || "").filter(Boolean).join(", ");
export const candidateExportRows = candidates => candidates.map(candidate => ({
  "N° PLD": String(candidate.pld ?? ""),
  "Nom": String(candidate.lastname || ""),
  "Prénom": String(candidate.firstname || ""),
  "Téléphone": String(candidate.phone || candidate.mobile || ""),
  "Email": String(candidate.email || ""),
  "Ville": String(candidate.town || ""),
  "Code postal": String(candidate.postCode || ""),
  "Qualifications": qualifications(candidate.qualifications || candidate.qualification),
  "Statut": String(candidate.status || ""),
}));
